import { transport } from 'config/transport';

export function callApiGetNoiTruReportForAllCongDoan(academicYear) {
    return transport.get(`/trunguong/report/noitru/data-annually`, { params: { academicYear } });
}
